

import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Header } from '../../Components/Layout/Header.jsx'
import { AccountTabletLinkovi } from '../../Components/Account/AccountTabletLinkovi.jsx'
import { RestrictedAccess } from '../../Components/Layout/RestrictedAccess.jsx'


import { CasinoLink } from '../../Components/Layout/CasinoLink.jsx'
import { Wallet2 } from '../../Components/Account/Wallet2.jsx'
import { AccountLinkovi } from '../../Components/Account/AccountLinkovi.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'

export class Account extends React.Component {


    constructor(props) {
        super(props);

        this.redirectDone = true;
        this.state = {
            redirectTo: '/', redirectToState: {}, promotions: null, activePokerReloadPromotion: null
        }

        this.props.fetchUserFn();
        this.logout = this.logout.bind(this);
        this.showUser = this.showUser.bind(this);
        this.doRedirect = this.doRedirect.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);

        this.fetchData();
        casino.utils.createPageGoogleTagManagerEvent('Moj Racun', 'Prijenos novca', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    showUser(user, sesijaId) {
        this.props.updateUserFn(user, sesijaId);
    }

    fetchData() {
        var promises = Promise.all([casino.repos.promotionRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }


    doRedirect(path, state) {
        this.redirectDone = false;
        this.setState({
            redirectTo: path,
            redirectToState: state
        });
    }

    logout(redirectToHome) {
        var that = this;

        this.props.showLoadingFn(true);
        casino.repos.sessionRepo.remove().then(function () {
            that.showUser(null, null);
            that.props.showLoadingFn(false);
        });

        if (redirectToHome) {
            that.doRedirect(this.props.getHomePathFn(this.props.route.location));
        }
    }

    setData(data) {
        var [promotions] = data;

        let activePokerReloadPromotion = false;
        let runningPokerReloadPromotion = false;
        if (promotions && promotions.availableItems)
            promotions.availableItems.map(x => {
                if (x.poker)
                    activePokerReloadPromotion = true;
            })

        if (promotions && promotions.runningItems)
            promotions.runningItems.map(x => {
                if (x.poker)
                    runningPokerReloadPromotion = true;
            })

        this.setState({
            promotions: promotions,
            activePokerReloadPromotion: activePokerReloadPromotion,
            runningPokerReloadPromotion: runningPokerReloadPromotion
        });
    }
    componentWillUnmount() {
        this.dataPromises.cancel();
    }

    renderCasinoAmount() {
        return <span className="ammount-primary">{casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivoZaIsplatu, this.props.user.valuta)}</span>
    }

    renderMainAmount() {
        return <span className="ammount-primary">{casino.utils.numberWithCurrencyFromated(this.props.user.sportRaspolozivo, this.props.user.valuta)}</span>

    }

    renderTotalAmount() {
        return (
            <div className="text text-33 relative">
                <span className="text text-33">{casino.utils.numberWithCurrencyFromated(this.props.user.ukupnoRaspolozivo, this.props.user.valuta)}</span>
            </div>
        )

    }

    render() {
        var pathName = this.props.route.match.url;

        var user = this.props.user;
        var aktivniBonus = user && user.promocije.runningItems.length > 0 && user.promocije.runningItems[user.promocije.runningItems.length - 1];
        let activePokerReloadPromotion = this.props.promotions && this.props.activePokerReloadPromotion;

        if (this.props.user) {
            return <div>
                <MetaTags title="Moj Račun | SuperSport Casino" description={" "} />
                <Route exact path={pathName} render={(route) =>
                    (<Header key="header" {...this.state} {...this.props} ></Header>)} />


                <div className="flex margin-1p-on-tablet">

                    <AccountTabletLinkovi {...this.props} ></AccountTabletLinkovi>

                    <div id="page-wrapper" className="white flex-expand-1 border-on-tablet no-padding">

                        <div className="header-2">
                            <h1 className="text">Moj račun</h1>
                            <CasinoLink className="action" href={casino.config.urls.uplata}>Uplata</CasinoLink>
                        </div>

                        <div className=" max-width-80">
                            <div className="text-center">
                                <div className="text text-31">{this.props.user.nadimak}</div>
                                <br />
                                <div className="text text-32">Ukupno raspoloživo</div>
                                {this.props.user && this.renderTotalAmount()}
                            </div>

                            <div className="text-center" style={{ padding: '2rem 1.5rem 0rem' }}>
                                <div className="money-box glavni">
                                    {this.props.user && this.renderMainAmount()}
                                    <span className="text">GLAVNI SPORT RAČUN</span>
                                </div>
                                <div className="money-box casino">
                                    {this.props.user && this.renderCasinoAmount()}
                                    <span className="text">CASINO & POKER RAČUN</span>
                                </div>
                            </div>
                            {!!this.props.user.casinoPrewagerBonusIznos && <div className="casino-prewger-bonus">
                                <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/bonuses')} >
                                    <span>CASINO BONUS</span>
                                    <span className="icon ico-chevron-right"></span>
                                    <span className="kn">{casino.utils.numberWithCurrencyFromated(this.props.user.casinoPrewagerBonusIznos, this.props.user.valuta)}</span>

                                </NavLink>
                                <hr></hr>

                            </div>}

                            <div className="text-center" style={{ padding: '1rem 1.5rem' }}>
                                <Wallet2 {...this.state} key="wallet2" {...this.props} fetchDataFn={this.fetchData}></Wallet2>
                            </div>


                        </div>


                        {aktivniBonus && aktivniBonus.active && !aktivniBonus.jePrewager && !aktivniBonus.jeFreeSpin && !aktivniBonus.poker &&

                            <div className=" max-width-80">
                                <hr></hr>
                                <NavLink to='/reload'>

                                    <div className=" reload-preostalo">
                                        <span>{aktivniBonus.naziv}</span><span className="icon ico-chevron-right" ></span> <span>
                                            {casino.utils.numberToKune((aktivniBonus.iznos - aktivniBonus.iznosIsplaceno)) + ' / ' + casino.utils.numberToEuro((aktivniBonus.iznos - aktivniBonus.iznosIsplaceno))}</span><span className="small-mobile-hidden">Preostalo</span>
                                    </div>
                                </NavLink>
                                {!this.state.runningPokerReloadPromotion && <hr></hr>}
                            </div>

                        }


                        {this.state.runningPokerReloadPromotion && this.state.promotions.runningItems[0].active &&

                            <div className=" max-width-80">
                                <hr></hr>
                                <NavLink to='/poker/bonuses/poker-reload'>
                                    <div className=" reload-preostalo poker">
                                        <span>Poker Reload Bonus</span><span className="icon ico-chevron-right" ></span> <span>
                                            {(this.state.promotions.runningItems[0].iznos - this.state.promotions.runningItems[0].iznosIsplaceno) + ' €' + ' / ' + ((this.state.promotions.runningItems[0].iznos - this.state.promotions.runningItems[0].iznosIsplaceno) * (7.53450)).toFixed(2) + ' kn'}</span><span className="small-mobile-hidden">Preostalo</span>
                                    </div>
                                </NavLink>
                                <hr></hr>
                            </div>

                        }

                        <div className="linkovi-grey  max-width-80">
                            <br ></br>

                            <div className="brzi-linkovi-account">
                                <CasinoLink href={casino.config.menu.Sport.url} ><span>Sport</span></CasinoLink>
                                <NavLink to={'/'}><span> Casino</span></NavLink>
                                <NavLink to={'/poker'}><span>Poker</span></NavLink>
                            </div>


                            {/* <hr></hr> */}
                            <br />


                            <Route exact path={pathName} render={(route) =>
                                (<AccountLinkovi key="linkovi" {...this.props} path={pathName}></AccountLinkovi>)} />
                            <hr />
                            <button className="link link-20 red" onClick={() => this.logout(true)}>
                                Odjavi me
                            </button>
                            {/* <hr /> */}
                            <br />
                            <br />
                        </div>

                    </div>


                </div>
            </div>

        } else {
            return <div>
                <Header key="header" {...this.state} {...this.props}></Header>
                <RestrictedAccess {...this.props} />


                {!this.redirectDone && this.state.redirectTo && <Redirect to={{ pathname: this.state.redirectTo, state: this.state.redirectToState }} />}
                {this.redirectDone = true}


            </div>

        }


    }
};
